import { render } from "./SessionList.vue?vue&type=template&id=7cc96210&scoped=true"
import script from "./SessionList.vue?vue&type=script&lang=js"
export * from "./SessionList.vue?vue&type=script&lang=js"

import "./SessionList.vue?vue&type=style&index=0&id=7cc96210&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7cc96210"

export default script